import { Link } from 'react-router-dom';
import { blogPosts } from '../../../mocks/blogPosts';

const allLinks = [
  { label: 'Etiket Malzeme Seçimi Rehberi', slug: 'etiket-malzeme-secimi', icon: 'ri-file-list-3-line' },
  { label: 'Dijital Baskı mı Flekso Baskı mı?', slug: 'dijital-vs-flekso-baski', icon: 'ri-printer-line' },
  { label: 'Gıda Etiketi Zorunlu Bilgiler', slug: 'gida-etiketi-zorunlu-bilgiler', icon: 'ri-restaurant-line' },
  { label: 'Kozmetik Etiket Baskısı', slug: 'kozmetik-etiket-baskisi-bioetiket', icon: 'ri-heart-pulse-line' },
  { label: 'Ümraniye Etiket Baskı Hizmetleri', slug: 'umraniye-etiket-basim-hizmetleri', icon: 'ri-map-pin-line' },
  { label: 'Yukarı Dudullu Etiket Baskı', slug: 'yukari-dudullu-etiket-baski', icon: 'ri-building-4-line' },
  { label: 'Ataşehir İşletmeleri Etiket Çözümleri', slug: 'atasehir-isletmeleri-etiket-cozumleri', icon: 'ri-store-2-line' },
];

export default function Blog() {
  const featured = blogPosts[0];
  const rest = blogPosts.slice(1, 4);

  return (
    <section id="blog" className="py-24 bg-[#FAFAF8]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Başlık */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-8 mb-16">
          <div>
            <span className="text-xs font-semibold tracking-widest text-[#FF6B35] uppercase">
              Bilgi Merkezi
            </span>
            <h2 className="text-5xl font-bold text-[#1A2332] leading-tight mt-3">
              Etiket Dünyası
            </h2>
            <h2 className="text-5xl font-bold italic text-[#FF6B35] leading-tight mt-1">
              Blog & Rehber
            </h2>
          </div>
          <div className="flex flex-col items-start lg:items-end gap-4">
            <p className="text-base text-gray-600 max-w-md leading-relaxed text-left lg:text-right">
              Etiket teknolojileri, malzeme seçimi ve tasarım ipuçları hakkında uzman görüşleri ve pratik bilgiler.
            </p>
            <Link
              to="/blog"
              className="inline-flex items-center px-6 py-3 text-sm font-semibold text-[#FF6B35] border-2 border-[#FF6B35] rounded-full hover:bg-[#FF6B35] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Tüm Makaleler
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>

        {/* Grid */}
        <div className="grid lg:grid-cols-5 gap-6">
          {/* Öne Çıkan Makale */}
          <Link
            to={`/blog/${featured.slug}`}
            className="lg:col-span-3 group bg-white rounded-3xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 cursor-pointer"
          >
            <div className="relative h-72 overflow-hidden">
              <img
                src={featured.image}
                alt={featured.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="eager"
                fetchpriority="high"
                decoding="async"
                width="900"
                height="600"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <span className="absolute top-4 left-4 bg-[#FF6B35] text-white text-xs font-semibold px-3 py-1 rounded-full">
                {featured.category}
              </span>
            </div>
            <div className="p-8">
              <div className="flex items-center gap-4 text-xs text-gray-400 mb-4">
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line"></i>
                  {new Date(featured.date).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  {featured.readTime} okuma
                </span>
              </div>
              <h3 className="text-2xl font-bold text-[#1A2332] mb-3 group-hover:text-[#FF6B35] transition-colors leading-snug">
                {featured.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-6 line-clamp-3">
                {featured.excerpt}
              </p>
              <div className="flex items-center gap-2 text-sm font-semibold text-[#FF6B35]">
                Devamını Oku
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </div>
            </div>
          </Link>

          {/* Yan Makaleler */}
          <div className="lg:col-span-2 flex flex-col gap-6">
            {rest.map((post) => (
              <Link
                key={post.id}
                to={`/blog/${post.slug}`}
                className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 flex cursor-pointer"
              >
                <div className="w-32 flex-shrink-0 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    decoding="async"
                    width="300"
                    height="300"
                  />
                </div>
                <div className="p-4 flex flex-col justify-between flex-1">
                  <div>
                    <span className="text-xs font-semibold text-[#FF6B35] uppercase tracking-wide">
                      {post.category}
                    </span>
                    <h3 className="text-sm font-bold text-[#1A2332] mt-1 mb-2 leading-snug group-hover:text-[#FF6B35] transition-colors line-clamp-2">
                      {post.title}
                    </h3>
                  </div>
                  <div className="flex items-center gap-3 text-xs text-gray-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {post.readTime}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i>
                      {new Date(post.date).toLocaleDateString('tr-TR', { day: 'numeric', month: 'short' })}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* Tüm Makale Linkleri — Google için iç bağlantı */}
        <div className="mt-14 bg-white rounded-3xl shadow-sm border border-gray-100 p-8">
          <h3 className="text-base font-bold text-[#1A2332] mb-6 flex items-center gap-2">
            <span className="w-6 h-6 flex items-center justify-center">
              <i className="ri-links-line text-[#FF6B35] text-lg"></i>
            </span>
            Tüm Rehber ve Makaleler
          </h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
            {allLinks.map((item) => (
              <Link
                key={item.slug}
                to={`/blog/${item.slug}`}
                className="flex items-center gap-3 px-4 py-3 rounded-xl bg-[#FAFAF8] hover:bg-orange-50 hover:text-[#FF6B35] text-gray-700 text-sm font-medium transition-all duration-200 group cursor-pointer border border-transparent hover:border-orange-100"
              >
                <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-white shadow-sm flex-shrink-0">
                  <i className={`${item.icon} text-[#FF6B35] text-sm`}></i>
                </span>
                <span className="leading-snug line-clamp-2">{item.label}</span>
                <span className="w-4 h-4 flex items-center justify-center ml-auto flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-arrow-right-s-line text-[#FF6B35]"></i>
                </span>
              </Link>
            ))}
            <Link
              to="/blog"
              className="flex items-center gap-3 px-4 py-3 rounded-xl bg-[#FF6B35] text-white text-sm font-semibold transition-all duration-200 cursor-pointer hover:bg-[#E55A2B]"
            >
              <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-white/20 flex-shrink-0">
                <i className="ri-article-line text-white text-sm"></i>
              </span>
              <span>Tüm Makaleleri Gör</span>
              <span className="w-4 h-4 flex items-center justify-center ml-auto flex-shrink-0">
                <i className="ri-arrow-right-s-line text-white"></i>
              </span>
            </Link>
          </div>
        </div>

        {/* Etiketler */}
        <div className="mt-8 flex flex-wrap gap-3 items-center">
          <span className="text-sm text-gray-500 font-medium">Popüler Konular:</span>
          {[
            { label: 'etiket baskı', slug: 'etiket-malzeme-secimi' },
            { label: 'malzeme seçimi', slug: 'etiket-malzeme-secimi' },
            { label: 'dijital baskı', slug: 'dijital-vs-flekso-baski' },
            { label: 'gıda etiketi', slug: 'gida-etiketi-zorunlu-bilgiler' },
            { label: 'kozmetik etiket', slug: 'kozmetik-etiket-baskisi-bioetiket' },
            { label: 'Ümraniye', slug: 'umraniye-etiket-basim-hizmetleri' },
            { label: 'Ataşehir', slug: 'atasehir-isletmeleri-etiket-cozumleri' },
          ].map((tag) => (
            <Link
              key={tag.slug + tag.label}
              to={`/blog/${tag.slug}`}
              className="text-xs px-4 py-2 bg-white border border-gray-200 rounded-full text-gray-600 hover:border-[#FF6B35] hover:text-[#FF6B35] transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              #{tag.label}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
